import React from 'react';
import { IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import Button from '@material-ui/core/Button';
import { Modal, Col, Row } from 'react-bootstrap';

export default function PopupModal(props) {
  const { show, onHide, text, showModalButton, onButtonClick, buttonText, isHeading, headingText,size, isMultiButton, buttonTwoText, onButtonTwoClick, type, typeTwo, modalClasses, headerClasses, bodyClasses,BodyComponent } = props;

  return (
    <Modal className={`insured-info-content ${modalClasses || ''}`} show={show} onHide={onHide} animation={false} centered>
      <Modal.Body className="d-flex align-items-center justify-content-center p-3 flex-column">
        <div className={`head-close ${headerClasses || ''}`}>
          {
            isHeading ? <h4>{headingText}</h4> : null
          }
          <IconButton className="close-button" aria-label="close" onClick={onHide}>
            <CloseIcon />
          </IconButton>
        </div>
        {text ? <p className={`pb-4 pt-2 text-center insured-info ${bodyClasses || ''}`} dangerouslySetInnerHTML={{ __html: text }}></p> : null}
        {BodyComponent ? <BodyComponent /> : null}
        {isMultiButton ?
          <Row className="mt-3">
            <Col className='pl-0'>
              <Button
                className='text-center btn-continue py-1 px-4'
                variant="outlined"
                size="large"
                color="primary"
                onClick={() => onButtonClick()}
                type={type ? type : ""}
              >
                {buttonText}
              </Button>
            </Col>
            <Col className="d-flex justify-content-end pr-0">
              <Button
                className='text-center btn-continue py-1 px-5'
                variant="contained"
                size="large"
                color="primary"
                onClick={() => onButtonTwoClick()}
                type={typeTwo ? typeTwo : ""}
              >
                {buttonTwoText}
              </Button>
            </Col>
          </Row> :
          showModalButton &&
          <Button className='text-center px-4 w-25'
            variant="contained"
            size={size ? size : "medium"}
            type={type ? type : ""}
            color="primary"
            onClick={() => onButtonClick()}
          >
            {buttonText}
          </Button>
        }
      </Modal.Body>
    </Modal>
  )
}


// WEBPACK FOOTER //
// ./src/components/Common/PopupModal.js